import { APIListResponse } from './response'
export interface User {
  id: 0
  first_name: string
  last_name: string
  username: string
  language_code: string
  is_admin: boolean
  is_driver: boolean
  is_background_checker: boolean
  is_ride_support: boolean
  is_supervisor: boolean
  is_business_partner: boolean
  is_broker: boolean
  shifts?: UserShift[]
  shiftDays: any[]
  company_id: number
  phone?: string
  email?: string
  is_email_notification?: boolean
  is_phone_notification?: boolean
}

export type UserRole =
  | 'admin'
  | 'background_checker'
  | 'ride_support'
  | 'business_partner'
  | 'broker'
  | 'driver'
  | 'supervisor'
  | undefined

export enum UserRoles {
  Admin = 'is_admin',
  Driver = 'is_driver',
  BackgroundChecker = 'is_background_checker',
  RideSupport = 'is_ride_support',
  Supervisor = 'is_supervisor',
  BusinessPartner = 'is_business_partner',
  Broker = 'is_broker',
}

export interface UserShift {
  telegram_user_id: number
  start_datetime: string
  end_datetime: string
  id: number
}

export interface UserShiftData {
  start_datetime: string
  end_datetime: string
}

export type UserList = APIListResponse<User>
